import './ChartWithAnomalies.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LineChart from '../../../../shared/components/chart/line-chart/LineChart';
import { getFirstSeriesPalette } from '../../../../shared/utils/chartTheme';
import { MonitorEventsResponse } from '../../../../shared/models/monitor/MonitorEventsResponse';

interface ChartWithAnomaliesProps {
  anomalies: MonitorEventsResponse[] | null;
  topPrompts: { rank: number; prompt: string; description: string }[] | null;
}

const ChartWithAnomalies: React.FC<ChartWithAnomaliesProps> = ({ anomalies, topPrompts }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="stats__panel">
        <div className="page-box__title-action">
          <div className="page-box__title page-box__title--flex">
            {t('insightPage.trendsAndAnomalies')}
          </div>
        </div>
        <div className="stats-box stats-box--without-margin stats-box--chart">
          <div className="stats-box__content">
            <LineChart
              firstData={[
                ['date', t('positive')],
                ['2022-20-20', 1],
              ]}
              marksData={anomalies}
              firstColorPalette={[getFirstSeriesPalette()[3]]}
              headers={['date', t('positive'), t('negative')]}
              onLegendClick={() => {}}
              smooth={true}
            />
          </div>
        </div>
      </div>
      <div className="stats__panel stats__panel--margin-top">
        <div className="stats-box">
          <div className="stats-box__content">
            <div className="top-prompts__table">
              {topPrompts?.map((ee) => {
                return (
                  <div className="top-prompts__row" key={ee.prompt}>
                    <div className="top-prompts__row-header">
                      <div className="top-prompts__rank">#{ee.rank}</div>
                      <div>{ee.prompt}</div>
                    </div>
                    <div className="top-prompts__row-desc">{ee.description}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChartWithAnomalies;
